import {
    AggregationKey,
    MyPortfolioCapsulesDataState,
} from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesDataState';
import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import orderBy from 'lodash/orderBy';
import { getTopic } from 'widgets/myPortfolioCapsules/topics/Topic';

export interface MyPortfolioCapsulesDataItem {
    symbol: string;
    qty: number;
    qtyTraded: number;
    qtyRemaining: number;
    value: number;
}

export function computeMyPortfolioCapsulesData(
    aggregatedData: MyPortfolioCapsulesDataState,
    aggregationKey: AggregationKey,
    config: MyPortfolioCapsulesWidgetConfigState,
    exchangeRate: number,
    suppressTop = false
): MyPortfolioCapsulesDataItem[] {
    const { topic: topicType, sort, numberToShow } = config;

    if (!topicType) {
        return [];
    }

    const topic = getTopic(topicType);

    const excludeZeros = topic.deriveShouldExcludeZeros(config);

    const symbolValues = topic
        .getSymbolValues(aggregatedData[aggregationKey], config, exchangeRate)
        .filter((v) => !excludeZeros || v.value > 0);

    const sorted = orderBy(symbolValues, 'value', sort);

    if (suppressTop) {
        return sorted;
    }

    return sorted.slice(0, numberToShow);
}
